import axiosClient from "./axiosClient";

export async function submitFeedbackCollector(report, screenshotBlob) {
  const form = new FormData();
  form.append(
    "report",
    new Blob([JSON.stringify(report)], { type: "application/json" }),
    "report.json"
  );
  if (screenshotBlob) {
    form.append("screenshot", screenshotBlob, "screenshot.jpg");
  }
  const res = await axiosClient.post("/feedback-collector/", form);
  return res.data;
}
